import React, { useEffect, useState, useContext } from 'react';
import { Form, Input, Button, Select, message, Card, Row, Col, Upload, Divider, Tooltip } from 'antd';
import { UploadOutlined, PictureOutlined, InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { LoginContext } from '../../../../context/loginContext';
import { GlobalContext } from '../../../../context/globalContext';
import CArticuloSupermercadoEmpresa from './CArticuloSupermercadoEmpresa';
import CArticuloIndumentariaEmpresa from './CArticuloIndumentariaEmpresa';
import CArticuloElectronicaEmpresa from './CArticuloElectronicaEmpresa';
import CArticuloElectrodomesticoEmpresa from './CArticuloElectrodomesticoEmpresa';
import CArticuloMuebleEmpresa from './CArticuloMuebleEmpresa';
import CArticuloJugueteEmpresa from './CArticuloJugueteEmpresa';
import CArticuloCosmeticoEmpresa from './CArticuloCosmeticoEmpresa';
import CImagenArtEmpresa from './CImagenArtEmpresa';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

const tipoMap = {
  supermercado: 1,
  indumentaria: 2,
  electronica: 3,
  electrodomésticos: 4,
  mueble: 5,
  juguete: 6,
  cosmetico: 7
};

const CCargarArticuloEmpresa = () => {
  const navigate = useNavigate();
  const { user } = useContext(LoginContext);
  const { categorias, tipoFraccionamientos } = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [nivel1, setNivel1] = useState([]);
  const [nivel2, setNivel2] = useState([]);
  const [nivel3, setNivel3] = useState([]);
  const [nivel4, setNivel4] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [categoriaTipo, setCategoriaTipo] = useState(null);
  const [files, setFiles] = useState([null, null, null]);
  const [urls, setUrls] = useState(['', '', '']);

  useEffect(() => {
    if (categorias.length > 0) {
      setNivel1(categorias.filter(cat => !cat.cat_padre_id));
    }
  }, [categorias]);

  // CAMBIO: ahora también reinicia nivel 4
  const onNivel1Change = (value) => {
    const hijos = categorias.filter(cat => cat.cat_padre_id === value);
    setNivel2(hijos);
    setNivel3([]);
    setNivel4([]);
    form.setFieldsValue({ nivel2: undefined, nivel3: undefined, nivel4: undefined });
    const tipoNombre = categorias.find(cat => cat.cat_id === value)?.cat_nombre.toLowerCase();
    setCategoriaTipo(tipoNombre);
  };

  // CAMBIO: reinicia nivel 4 al cambiar nivel 2
  const onNivel2Change = (value) => {
    const hijos = categorias.filter(cat => cat.cat_padre_id === value);
    setNivel3(hijos);
    setNivel4([]);
    form.setFieldsValue({ nivel3: undefined, nivel4: undefined });
  };

  // NUEVO: carga nivel 4 al elegir nivel 3
  const onNivel3Select = (value) => {
    setSelectedCategoria(value);
    const hijos = categorias.filter(cat => cat.cat_padre_id === value);
    setNivel4(hijos);
    form.setFieldsValue({ nivel4: undefined });
  };

  const onFinish = async () => {
    try {
      setLoading(true);

      // Obtenés todos los valores del form, incluyendo los campos dinámicos
      const values = form.getFieldsValue(true);

      const tipo_id = tipoMap[categoriaTipo];
      const formData = new FormData();

      // Agregás todos los valores al FormData de forma dinámica
      Object.entries(values).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });

      formData.append('tipo_id', tipo_id);
      formData.append('empresa', user.emp_id);
      formData.append('categoria_id', values.nivel4 || values.nivel3);

      files.forEach((file, i) => {
        if (file) {
          formData.append(`imagen${i === 0 ? '' : i + 1}`, file);
        } else if (urls[i]) {
          formData.append(`imagen${i === 0 ? '' : i + 1}_url`, urls[i]);
        }
      });

      const res = await fetch(`${process.env.REACT_APP_API_URL}/articulos/empresa`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${user.token}` },
        body: formData
      });

      if (!res.ok) throw new Error('Error al crear el artículo');

      message.success('Artículo creado correctamente');
      form.resetFields();
      setFiles([null, null, null]);
      setUrls(['', '', '']);
      navigate('/lista-articulo-empresa');
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };


  const renderFormByTipo = () => {
    switch (categoriaTipo) {
      case 'supermercado': return <CArticuloSupermercadoEmpresa form={form} />;
      case 'indumentaria': return <CArticuloIndumentariaEmpresa form={form} />;
      case 'electrónica': return <CArticuloElectronicaEmpresa form={form} />;
      case 'electrodomésticos': return <CArticuloElectrodomesticoEmpresa form={form} />;
      case 'mueble': return <CArticuloMuebleEmpresa form={form} />;
      case 'juguete': return <CArticuloJugueteEmpresa form={form} />;
      case 'cosmético': return <CArticuloCosmeticoEmpresa form={form} />;
      default: return null;
    }
  };


  return (
    <div style={{ maxWidth: 1100, margin: '2rem auto', padding: '0.5rem' }}>

      <Form form={form} layout="vertical" onFinish={onFinish}>
        {/* Sección Categorías */}
        <Divider orientation="left">Categoría</Divider>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name="nivel1" label="Nivel 1" rules={[{ required: true }]}>
              <Select onChange={onNivel1Change} placeholder="Seleccione">
                {nivel1.map(cat => (
                  <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="nivel2" label="Nivel 2" rules={[{ required: true }]}>
              <Select onChange={onNivel2Change} placeholder="Seleccione">
                {nivel2.map(cat => (
                  <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="nivel3" label="Nivel 3" rules={[{ required: true }]}>
              <Select onChange={onNivel3Select} placeholder="Seleccione">
                {nivel3.map(cat => (
                  <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="nivel4" label="Nivel 4">
              <Select placeholder="Seleccione">
                {nivel4.map(cat => (
                  <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Sección Info General */}
        <Divider orientation="left">Datos del artículo</Divider>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="aem_nombre" label="Nombre" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="aem_sku" label="SKU" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="aem_marca" label="Marca">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="aem_codbarra" label="Código de barras">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="aem_tipo_unidad" label="Tipo de Unidad" rules={[{ required: true }]}>
              <Select placeholder="Seleccione el tipo de unidad">
                {tipoFraccionamientos.map((tipo) => (
                  <Option key={tipo.tfr_id} value={tipo.tfr_id}>
                    {tipo.tfr_nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="aem_descripcion_corta" label="Descripción Corta">
              <Input.TextArea rows={2} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="aem_descripcion_larga" label="Descripción Larga">
              <Input.TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>

        {/* Sección dinámica según tipo */}
        {renderFormByTipo()}

        {/* Sección Imágenes */}
        <Divider orientation="left"><PictureOutlined /> Imágenes del artículo</Divider>
        <Row gutter={24}>
          {[0, 1, 2].map((index) => (
            <Col span={8} key={index}>
              <div style={{
                padding: 16,
                borderRadius: 8,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                backgroundColor: '#fafafa',
                marginBottom: 16
              }}>
                <h4 style={{ marginBottom: 8 }}>
                  Imagen {index === 0 ? 'Principal' : index + 1}{' '}
                  <Tooltip title="Podés ingresar una URL o subir un archivo de imagen. Si subís una imagen, se usará en lugar de la URL.">
                    <InfoCircleOutlined style={{ fontSize: 16, color: '#1890ff' }} />
                  </Tooltip>
                </h4>
                <Form.Item label="URL">
                  <Input
                    placeholder="https://..."
                    value={urls[index]}
                    onChange={(e) => {
                      const value = e.target.value;
                      setUrls(prev => {
                        const updated = [...prev];
                        updated[index] = value;
                        return updated;
                      });
                    }}
                  />
                </Form.Item>
                <Form.Item label="O subir archivo">
                  <Upload
                    beforeUpload={(file) => {
                      setFiles(prev => {
                        const updated = [...prev];
                        updated[index] = file;
                        return updated;
                      });
                      return false;
                    }}
                    showUploadList={false}
                  >
                    <Button icon={<UploadOutlined />}>Subir Imagen</Button>
                  </Upload>
                </Form.Item>
              </div>
            </Col>
          ))}
        </Row>

        <CImagenArtEmpresa files={files} urls={urls} setFiles={setFiles} setUrls={setUrls} />

        <Form.Item style={{ textAlign: 'center', marginTop: 32 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Guardar artículo
          </Button>
        </Form.Item>
      </Form>
    </div>

  );
};

export default CCargarArticuloEmpresa;